// extracted by mini-css-extract-plugin
export default {"input":"styles_input__6qYMp","icon":"styles_icon__9QeAP","box_icon_left":"styles_box_icon_left__c0A66","box_icon_right":"styles_box_icon_right__SWXDP"};